/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InsuranceCompanySchema } from './InsuranceCompanySchema';
import type { InsuranceTypeOptions } from './InsuranceTypeOptions';
import type { LocationSchema } from './LocationSchema';
import type { SexOptions } from './SexOptions';
import type { TagSchema } from './TagSchema';
export type PatientProfileDetailSchema = {
    id: string;
    name: string;
    sex: SexOptions;
    insurance_company: (InsuranceCompanySchema | null);
    insurance_type: (InsuranceTypeOptions | null);
    language: PatientProfileDetailSchema.language;
    last_visit_id: (string | null);
    last_visit_date: (string | null);
    last_visit_user_id: (string | null);
    next_visit_id: (string | null);
    next_visit_date: (string | null);
    next_visit_user_id: (string | null);
    visit_count: number;
    visit_absent_count: number;
    waiting: (string | null);
    waiting_duration: (number | null);
    waiting_service: (string | null);
    waiting_user: (string | null);
    has_unpaid_visit?: (boolean | null);
    expiring_ft_ticket_id: (string | null);
    expiring_ft_ticket_expiration_date: (string | null);
    location: (LocationSchema | null);
    m_id: (number | null);
    tags: Array<TagSchema>;
    first_name?: (string | null);
    last_name: string;
    nin?: (string | null);
    email_address?: (string | null);
    phone?: (string | null);
    address?: (string | null);
    birth_date_year?: (number | null);
    birth_date_month?: (number | null);
    birth_date_day?: (number | null);
    gdpr_consent?: boolean;
    gdpr_confirm_date?: (string | null);
    note?: (string | null);
    legal_representative?: (string | null);
    insurance_number?: (string | null);
    insurance_payment_type?: (string | null);
    insurance_company_change?: (string | null);
    receive_newsletter_consent?: boolean;
    allow_reservations?: boolean;
    questionnaire?: (string | null);
};
export namespace PatientProfileDetailSchema {
    export enum language {
        CS = 'cs',
        EN = 'en',
        SK = 'sk',
        PL = 'pl',
    }
}

